export const engagementAppGroupIdWhatsappMmLiteApiStatus = "/engagement/:app_group_id/whatsapp/mm_lite_api_status";
